export const CardFormFragmentTransition = {
  entering: { height: 344, minHeight: 344 },
  entered: { height: 344, minHeight: 344 },
  exiting: { height: 0, minHeight: 0 },
  exited: { height: 0, minHeight: 0 },
};
